import { Component, input } from '@angular/core';

@Component({
  selector: 'app-igloo-logo',
  standalone: true,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6"
        y="14"
        width="20"
        height="15"
        rx="3.5"
        [attr.fill]="color()"
        fill-opacity="0.15"
        [attr.stroke]="color()"
        stroke-width="1.5"
      />
      <path
        d="M11 14v-3.5a5 5 0 0 1 10 0V14"
        [attr.stroke]="color()"
        stroke-width="1.75"
        stroke-linecap="round"
      />
      <circle cx="16" cy="21.5" r="2.5" [attr.fill]="color()" />
      <rect x="15" y="21.5" width="2" height="3" rx="1" [attr.fill]="color()" />
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class IglooLogoComponent {
  /** Color of the logo. Defaults to Igloo brand color. */
  color = input<string>('#0cc8a0');

  /** Size of the logo in pixels. Defaults to 28. */
  size = input<number>(28);
}
